(function () {
  window.PDPSwiperSlider = {
    init(scope) {
      const root = scope instanceof Element ? scope : document;
      const sliders = root.querySelectorAll('.pdSwiperSlider');

      sliders.forEach((slider) => {
        this.destroySingle(slider);
        this.initSingle(slider);
      });
    },

    initSingle(slider) {
      if (!slider || slider.dataset.pdpSwiperInitialized === 'true') return;

      const thumbsContainer = slider.querySelector('.slider__thumbs .swiper-container');
      const imagesContainer = slider.querySelector('.slider__images .swiper-container');
      const nextBtn = slider.querySelector('.slider__next');
      const prevBtn = slider.querySelector('.slider__prev');

      if (!thumbsContainer || !imagesContainer) return;
      if (typeof Swiper !== 'function') return;

      const sliderThumbs = new Swiper(thumbsContainer, {
        direction: 'vertical',
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        breakpoints: {
          0: {
            direction: 'horizontal'
          },
          768: {
            direction: 'vertical'
          }
        },
        on: {
          init: function () {
            playActiveSlideVideo(this);
          },
          slideChange: function () {
            playActiveSlideVideo(this);
          },
          update: function () {
            playActiveSlideVideo(this);
          }
        }
      });

      const sliderImages = new Swiper(imagesContainer, {
        direction: 'vertical',
        slidesPerView: 1,
        mousewheel: true,
        grabCursor: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        thumbs: {
          swiper: sliderThumbs
        },
        breakpoints: {
          0: {
            direction: 'horizontal'
          },
          768: {
            direction: 'vertical'
          }
        },
        on: {
          init: function () {
            playActiveSlideVideo(this);
          },
          slideChange: function () {
            playActiveSlideVideo(this);
          },
          update: function () {
            playActiveSlideVideo(this);
          }
        }
      });

      slider._pdpThumbsSwiper = sliderThumbs;
      slider._pdpImagesSwiper = sliderImages;
      slider.dataset.pdpSwiperInitialized = 'true';

      setSliderHeight(slider);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (slider._pdpThumbsSwiper) slider._pdpThumbsSwiper.update();
          if (slider._pdpImagesSwiper) slider._pdpImagesSwiper.update();
          setSliderHeight(slider);
        });
      });

      setTimeout(() => {
        if (slider._pdpThumbsSwiper) slider._pdpThumbsSwiper.update();
        if (slider._pdpImagesSwiper) slider._pdpImagesSwiper.update();
        setSliderHeight(slider);
      }, 200);
    },

    destroy(scope) {
      const root = scope instanceof Element ? scope : document;
      const sliders = root.querySelectorAll('.pdSwiperSlider');

      sliders.forEach((slider) => {
        this.destroySingle(slider);
      });
    },

    destroySingle(slider) {
      if (!slider) return;

      if (slider._pdpImagesSwiper && typeof slider._pdpImagesSwiper.destroy === 'function') {
        try {
          slider._pdpImagesSwiper.destroy(true, true);
        } catch (e) {
          console.warn('Images swiper destroy failed:', e);
        }
        slider._pdpImagesSwiper = null;
      }

      if (slider._pdpThumbsSwiper && typeof slider._pdpThumbsSwiper.destroy === 'function') {
        try {
          slider._pdpThumbsSwiper.destroy(true, true);
        } catch (e) {
          console.warn('Thumbs swiper destroy failed:', e);
        }
        slider._pdpThumbsSwiper = null;
      }

      slider.dataset.pdpSwiperInitialized = 'false';

      slider.querySelectorAll('.swiper-container').forEach((container) => {
        container.classList.remove(
          'swiper-initialized',
          'swiper-horizontal',
          'swiper-vertical',
          'swiper-backface-hidden',
          'swiper-thumbs'
        );
        container.removeAttribute('style');
      });

      slider.querySelectorAll('.swiper-wrapper').forEach((wrapper) => {
        wrapper.removeAttribute('style');
      });

      slider.querySelectorAll('.swiper-slide').forEach((slide) => {
        slide.removeAttribute('style');
        slide.classList.remove(
          'swiper-slide-thumb-active',
          'swiper-slide-visible',
          'swiper-slide-active',
          'swiper-slide-next',
          'swiper-slide-prev'
        );
      });
    }
  };

  window.CustomAjaxSectionScripts = {
    init(scope) {
      const root = scope instanceof Element ? scope : document;
      //this.initReviewVideoSlider(root);
      this.initAccordion(root);
      this.initTabs(root);
      this.initSeeMore(root);
    },

    initReviewVideoSlider(scope) {
      const root = scope instanceof Element ? scope : document;
      const sliders = root.querySelectorAll('.review-video-row');

      sliders.forEach((slider) => {
        if (slider.dataset.reviewSwiperInit === 'true') return;
        slider.dataset.reviewSwiperInit = 'true';

        if (typeof Swiper !== 'function') {
          console.log('Swiper not loaded');
          return;
        }

        let sectionRoot =
          slider.closest('[id^="shopify-section-"]') ||
          slider.closest('section') ||
          slider.parentElement ||
          document;

        const nextBtn = document.querySelector('[data-next-arrows]');
        const prevBtn = document.querySelector('[data-prev-arrows]');

        try {
          slider._reviewSwiperInstance = new Swiper(slider, {
            slidesPerView: 3.2,
            spaceBetween: 5,
            navigation:
              nextBtn && prevBtn
                ? {
                    nextEl: nextBtn,
                    prevEl: prevBtn
                  }
                : false,
            breakpoints: {
              768: {
                slidesPerView: 3,
                spaceBetween: 5
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 5
              }
            }
          });
        } catch (e) {
          console.warn('Review video swiper init failed:', e);
        }
      });

      const popups = root.querySelectorAll('.real-video-popup');

      popups.forEach((popup) => {
        if (!popup.dataset.movedToBody) {
          document.body.appendChild(popup);
          popup.dataset.movedToBody = 'true';
        }

        const popupBox = popup.querySelector('.real-video-add');
        const closeBtn = popup.querySelector('.close-button');

        root.querySelectorAll('.real-result-image').forEach((card) => {
          if (card.dataset.videoInit === 'true') return;
          card.dataset.videoInit = 'true';

          card.addEventListener('click', function (e) {
            e.preventDefault();

            const videoHolder = card.querySelector('.video-tag');
            const currentVideoEl = popupBox ? popupBox.querySelector('video') : null;

            if (!videoHolder || !popupBox) return;

            if (card.classList.contains('played')) {
              popup.classList.remove('open');

              if (currentVideoEl) {
                currentVideoEl.pause();
                currentVideoEl.currentTime = 0;
              }

              popupBox.innerHTML = '';
              card.classList.remove('played');
              return;
            }

            if (currentVideoEl) {
              currentVideoEl.pause();
              currentVideoEl.currentTime = 0;
            }

            document.querySelectorAll('.real-result-image.played').forEach((el) => {
              el.classList.remove('played');
            });

            popupBox.innerHTML = videoHolder.innerHTML;
            popup.classList.add('open');

            const newVideoEl = popupBox.querySelector('video');
            if (newVideoEl) {
              newVideoEl.play().catch(function () {});
            }

            card.classList.add('played');
          });
        });

        if (closeBtn && !closeBtn.dataset.videoCloseInit) {
          closeBtn.dataset.videoCloseInit = 'true';

          closeBtn.addEventListener('click', function () {
            const currentVideoEl = popupBox ? popupBox.querySelector('video') : null;

            popup.classList.remove('open');

            if (currentVideoEl) {
              currentVideoEl.pause();
              currentVideoEl.currentTime = 0;
            }

            if (popupBox) popupBox.innerHTML = '';

            document.querySelectorAll('.real-result-image.played').forEach((el) => {
              el.classList.remove('played');
            });
          });
        }
      });
    },

    initAccordion(scope) {
      const root = scope instanceof Element ? scope : document;

      root.querySelectorAll('.accordion-header').forEach((header) => {
        if (header.dataset.accordionInit === 'true') return;
        header.dataset.accordionInit = 'true';

        header.addEventListener('click', function () {
          const parent = header.closest('.cutmStaxtx');
          if (!parent) return;

          const content = parent.querySelector('.accordion-content');
          const icon = header.querySelector('.accordion-icon');

          root.querySelectorAll('.cutmStaxtx').forEach((item) => {
            if (item !== parent) {
              item.classList.remove('active');

              const otherContent = item.querySelector('.accordion-content');
              const otherIcon = item.querySelector('.accordion-icon');

              if (otherContent) otherContent.style.maxHeight = null;
              if (otherIcon) otherIcon.textContent = '+';
            }
          });

          parent.classList.toggle('active');

          if (parent.classList.contains('active')) {
            if (content) content.style.maxHeight = content.scrollHeight + 'px';
            if (icon) icon.textContent = '−';
          } else {
            if (content) content.style.maxHeight = null;
            if (icon) icon.textContent = '+';
          }
        });
      });
    },

    initTabs(scope) {
      const root = scope instanceof Element ? scope : document;

      root.querySelectorAll('.tab-link').forEach((link) => {
        if (link.dataset.tabInit === 'true') return;
        link.dataset.tabInit = 'true';

        link.addEventListener('click', function (e) {
          e.preventDefault();

          root.querySelectorAll('.tab-link').forEach(function (tab) {
            if (tab.parentNode) {
              tab.parentNode.classList.remove('active');
            }
          });

          if (this.parentNode) {
            this.parentNode.classList.add('active');
          }

          const targetId = this.getAttribute('href');
          const targetElement = root.querySelector(targetId) || document.querySelector(targetId);

          if (!targetElement || !window.jQuery) return;

          window
            .jQuery(targetId)
            .children('.detailsDescrips')
            .slideDown()
            .parent('.tab-content')
            .addClass('active')
            .siblings('.tab-content')
            .removeClass('active')
            .children('.detailsDescrips')
            .slideUp();

          if (targetElement.parentNode) {
            targetElement.parentNode.scrollIntoView({
              behavior: 'smooth'
            });
          }
        });
      });
    },

    initSeeMore(scope) {
      const root = scope instanceof Element ? scope : document;

      root.querySelectorAll('.j1q-N').forEach((btn) => {
        if (btn.dataset.seeMoreInit === 'true') return;
        btn.dataset.seeMoreInit = 'true';

        btn.addEventListener('click', function () {
          root.querySelectorAll('.cutmStaxtx').forEach((item) => {
            item.classList.toggle('active');
          });

          btn.classList.toggle('SeeMore2');
          if (btn.classList.contains('SeeMore2')) {
            btn.textContent = 'Show more...';
          } else {
            btn.textContent = 'Show less...';
          }
        });
      });
    }
  };

  function playActiveSlideVideo(swiper) {
    if (!swiper || !swiper.slides) return;

    swiper.slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (video) {
        video.pause();
      }
    });

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const activeVideo = activeSlide.querySelector('video');
    if (activeVideo) {
      activeVideo.currentTime = 0;
      activeVideo.play().catch(() => {});
    }
  }

  function setSliderHeight(scope) {
    const root = scope instanceof Element ? scope : document;
    const sliderImagesContainer = root.querySelector('.slider__images .swiper-container');

    if (!sliderImagesContainer) return;

    if (window.innerWidth >= 768) {
      sliderImagesContainer.style.height = `${window.innerHeight * 0.9}px`;
    } else {
      sliderImagesContainer.style.height = 'auto';
    }
  }

  function waitForSectionImages(sectionEl) {
    const images = Array.from(sectionEl.querySelectorAll('img'));

    if (!images.length) return Promise.resolve();

    return Promise.all(
      images.map((img) => {
        if (img.complete) return Promise.resolve();

        return new Promise((resolve) => {
          const done = () => resolve();
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        });
      })
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (window.PDPSwiperSlider) {
      window.PDPSwiperSlider.init(document);
    }

    if (window.CustomAjaxSectionScripts) {
      window.CustomAjaxSectionScripts.init(document);
    }
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.pdSwiperSlider').forEach((slider) => {
      setSliderHeight(slider);

      if (slider._pdpThumbsSwiper) slider._pdpThumbsSwiper.update();
      if (slider._pdpImagesSwiper) slider._pdpImagesSwiper.update();
    });
  });

  document.addEventListener('change', async function (event) {
    const radio = event.target.closest('.bundle-product-item input[type="radio"]');
    if (!radio) return;

    const bundleItem = radio.closest('.bundle-product-item');
    if (!bundleItem) return;

    const productUrl = bundleItem.dataset.productUrl;
    if (!productUrl) return;

    const currentSectionEl = bundleItem.closest('[id^="shopify-section-"]');
    if (!currentSectionEl) return;

    const sectionId = currentSectionEl.id.replace('shopify-section-', '');
    if (!sectionId) return;

    if (bundleItem.classList.contains('is-switching')) return;

    bundleItem.classList.add('is-switching');
    currentSectionEl.classList.add('is-loading');

    try {
      if (window.PDPSwiperSlider) {
        window.PDPSwiperSlider.destroy(currentSectionEl);
      }

      const response = await fetch(`${productUrl}?section_id=${sectionId}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load section HTML: ${response.status}`);
      }

      const htmlText = await response.text();
      const parsedDocument = new DOMParser().parseFromString(htmlText, 'text/html');
      const newSectionEl = parsedDocument.querySelector(`#shopify-section-${sectionId}`);

      if (!newSectionEl) {
        throw new Error(`Section #shopify-section-${sectionId} not found in response.`);
      }

      const oldSectionEl = document.querySelector(`#shopify-section-${sectionId}`);
      if (!oldSectionEl) {
        throw new Error(`Current section #shopify-section-${sectionId} not found.`);
      }

      oldSectionEl.replaceWith(newSectionEl);

      await waitForSectionImages(newSectionEl);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          try {
            if (
              window.PXUTheme &&
              window.PXUTheme.jsProduct &&
              typeof window.PXUTheme.jsProduct.init === 'function' &&
              window.jQuery
            ) {
              window.PXUTheme.jsProduct.init(window.jQuery(newSectionEl));
            }
          } catch (e) {
            console.warn('Theme product init failed:', e);
          }

          try {
            if (
              window.Shopify &&
              window.Shopify.PaymentButton &&
              typeof window.Shopify.PaymentButton.init === 'function'
            ) {
              window.Shopify.PaymentButton.init();
            }
          } catch (e) {
            console.warn('Payment button init failed:', e);
          }

          try {
            if (
              window.ShopifyXR &&
              typeof window.ShopifyXR.setupXRElements === 'function'
            ) {
              window.ShopifyXR.setupXRElements();
            }
          } catch (e) {
            console.warn('Shopify XR init failed:', e);
          }

          try {
            if (window.PDPSwiperSlider) {
              window.PDPSwiperSlider.init(newSectionEl);
            }
          } catch (e) {
            console.warn('Custom PDP Swiper init failed:', e);
          }

          try {
            if (window.CustomAjaxSectionScripts) {
              window.CustomAjaxSectionScripts.init(newSectionEl);
            }
          } catch (e) {
            console.warn('Custom section scripts init failed:', e);
          }
        });
      });

      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', productUrl);
      }

      document.dispatchEvent(
        new CustomEvent('bundle:product-switched', {
          detail: {
            productId: bundleItem.dataset.productId,
            productHandle: bundleItem.dataset.productHandle,
            variantId: bundleItem.dataset.firstVariantId,
            productUrl,
            sectionId
          }
        })
      );
    } catch (error) {
      console.error('Bundle switch failed:', error);
    } finally {
      bundleItem.classList.remove('is-switching');

      const sectionAfterReplace = document.querySelector(`#shopify-section-${sectionId}`);
      if (sectionAfterReplace) {
        sectionAfterReplace.classList.remove('is-loading');
      }
    }
  });

  $(document).ready(function () {
    $(document).on('click', '.swatch__option label', function () {
      $(this)
        .find('.tooltipData')
        .show()
        .parents('.swatch__option')
        .siblings('.swatch__option')
        .find('.tooltipData')
        .hide();
    });

    $(document).on('click', '[JSUpsellsCart]', function (e) {
      e.preventDefault();
      var mainObjj = $(this),
        dataProductId = $(this).parents('.product-block-additional-product').attr('data-productghPdp');
      $(this).attr('checked', true);
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        method: 'Post',
        data: {
          id: $(this).val(),
          quantity: 1
        },
        success: function () {
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            success: function (cart) {
              cart.items.forEach(function (item) {
                if (dataProductId == item.product_id) {
                  $('.product-block-additional-product[data-productghPdp="' + dataProductId + '"]').addClass('hide');
                }
              });
              mainObjj.attr('checked', true);
              var itemsCount = cart.item_count;
              $('.header-cart').addClass('has-cart-count');
              $('.header-cart__count').html(itemsCount);
              $('.header-cart__icon').addClass('has-cart-count');
              $('.header-cart__count').html(itemsCount);
            }
          });
        }
      });
    });

    document.addEventListener('UPEZ__CART_REFETCHED_AFTER_CHANGE', (e) => {
      const cart = e.detail.cart;
      const getCartItem = [];
      if (cart.item_count > 0) {
        cart.items.forEach(function (item) {
          getCartItem.push(item.product_id);
        });
      } else {
        document.querySelectorAll('.product-block-additional-product').forEach((elm) => {
          elm.classList.remove('hide');
        });
      }
      document.querySelectorAll('.product-block-additional-product').forEach((elm) => {
        var checkElm = parseInt(elm.getAttribute('data-productghpdp'));
        if (getCartItem.indexOf(checkElm) !== -1) {
          elm.classList.add('hide');
        } else {
          elm.classList.remove('hide');
        }
      });
    });

    $(document).on('click', '.detailsDescripss', function (e) {
      e.preventDefault();
      $(this)
        .siblings('.detailsDescrips')
        .slideToggle()
        .parent('.tab-content')
        .toggleClass('active')
        .siblings('.tab-content')
        .removeClass('active')
        .children('.detailsDescrips')
        .slideUp();
    });
  });
})();